import script from "./UserEditionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserEditionPage.vue?vue&type=script&setup=true&lang=ts"

import "./UserEditionPage.vue?vue&type=style&index=0&id=5dcb574f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcb574f"]])

export default __exports__